import React, { LegacyRef, useEffect, useRef, useState } from "react";
import { YhBox } from "@components/YhBox";
import { FormItemTypeEnum, ISelectOption, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import { useNoticeDetailModel } from "./detailModel";
import { Button, Col, Form, Image, Select, Spin, TreeSelect, Upload, Divider, message } from "antd";
import BraftEditor, { ControlType, ExtendControlType } from 'braft-editor'
import 'braft-editor/dist/index.css'
import { useNoticeModel } from "../summary/summaryModel";
import { noticeService } from "../NoticeService";
import useGlobalModel from "@src/model/globalModel";
import moment from "moment";
import { ReceiverTypeDs } from "@src/types/FmsDs";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import { importPropsConfig } from "@src/utils/importFile";
import FontIcon from "@src/components/YhIcon";
import { UploadOutlined } from "@ant-design/icons";
import { disabledDate, disabledDateTime } from "@src/utils/utils";
import { IFileFields } from "../NoticeTypes";
import { DetailDrawer } from "../summary/DetailDrawer";
import { getBaseRequestUrl, getToken, getBaseImgUploadUrl, getBaseImgLookUrl, getBaseUploadData } from "@src/utils/constants";
import { OptionDsType } from "@src/types/FmsTypes";
import { YhAuth } from "@src/components/auth/YhAuth";
import useNavModel from "@src/model/navModel";
import { ContentUtils } from 'braft-utils';
import Table from 'braft-extensions/dist/table';
import 'braft-editor/dist/index.css'
import 'braft-extensions/dist/table.css'
import ErrorBoundary from "antd/lib/alert/ErrorBoundary";
import ErrorBoundary1 from "./error";

// 输出表格默认不带边框，如果需要边框，设置参数exportAttrString为'border="1" style="border-collapse: collapse"'
const options = {
	defaultColumns: 5, // 默认列数
	defaultRows: 5, // 默认行数
	withDropdown: true, // 插入表格前是否弹出下拉菜单
	columnResizable: true, // 是否允许拖动调整列宽，默认false
	exportAttrString: 'border="1" style="border-collapse: collapse"', // 指定输出HTML时附加到table标签上的属性字符串
	// includeEditors: ['id-1'], // 指定该模块对哪些BraftEditor生效，不传此属性则对所有BraftEditor有效
	// excludeEditors: ['id-2']  // 指定该模块对哪些BraftEditor无效
};

const controls: ControlType[] = [
	'undo',
	'redo',
	'bold',
	'font-size',
	'blockquote',
	'line-height',
	'letter-spacing',
	'text-color',
	'italic',
	'underline',
	'strike-through',
	'superscript',
	'subscript',
	'text-color',
	'separator',
	'link',
	'separator',
	'list-ol',
	'list-ul',
	'headings',
	'emoji',
	'text-indent',
	'text-align',
	'code',
	'hr',
	'clear'
]

export function NoticeDetail() {
	const {
		loading,
		userList,
		receiverTypeCode,
		formRef,
		onSubmit,
		formCache,
		setformCache,
		onPreview,
		debounceFetcher,
		onLoadUserByOrg,
		cacheData,
	} = useNoticeDetailModel();
	const { selectedRowData, editModel } = useNoticeModel()
	const { replaceNav, selectedNavId, closeNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
	// const [limitTimeDisabled, setLimitTimeDisabled] = useState<boolean>(true)
	BraftEditor.use(Table(options));
	const {
		noticeTypeDs,
		orgDs,
	} = useNoticeModel();

	const {
		user
	} = useGlobalModel();


	useEffect(() => {
		setformCache(undefined)
		return () => {
			setformCache(undefined)
		}
	}, [])

	const filterOption = (inputValue: string, option: OptionDsType) => option.label.includes(inputValue)

	const formConfig: IYhForm = {
		formRef,
		labelCol: { span: 6 },
		disabled: editModel === 'look',
		initialValues: formCache ? {
			...formCache
		} : editModel === "add" ? {
			receiverTypeCode: receiverTypeCode ?? 'ALL',
			authorCode: user.userCode,
			authorName: user.userName,
		} : {
					...selectedRowData,
					attachCode: selectedRowData?.attachInfo?.map(item => {
						return {
							uid: item.fileCode,
							name: item.attachName,
							size: item.fileSize,
							type: item.fileType
						}
					}),
					content: BraftEditor.createEditorState(selectedRowData?.contentHtml),
					receiverTypeCode: receiverTypeCode ?? selectedRowData?.receiverTypeCode,
					receiverValue: selectedRowData?.receiverTypeCode === "USER" ? "yh" : selectedRowData?.receiverValue,
					receiverUserCode: selectedRowData?.receiverTypeCode === "USER" ? selectedRowData?.receiverValue : [],
					limitTime: selectedRowData?.limitTime ? moment(selectedRowData?.limitTime) : '',
					pubTime: selectedRowData?.pubTime ? moment(selectedRowData?.pubTime) : '',
					allTime: selectedRowData?.limitTime === "2099-10-30T00:00:00",
				},
		justify: 'start',
		items: [
			{
				type: FormItemTypeEnum.Input,
				hidden: true,
				fieldLabel: "code",
				fieldName: 'code',
				span: 12
			}, {
				type: FormItemTypeEnum.Input,
				fieldLabel: "公告标题",
				fieldName: "title",
				span: 12,
				rules: [
					{ required: true, message: "请输入公告标题" }
				],
			}, {
				type: FormItemTypeEnum.Select,
				fieldLabel: "公告类型",
				fieldName: "noticeTypeCode",
				span: 12,
				ds: noticeTypeDs,
				filterOption: (inputValue: string, option: ISelectOption) => option.label.includes(inputValue),
				rules: [
					{ required: true, message: "请选择公告类型" }
				],
			}, {
				type: FormItemTypeEnum.Input,
				fieldLabel: "创建人",
				fieldName: "authorName",
				disable: true,
				span: 12,
			}, {
				type: FormItemTypeEnum.Input,
				fieldLabel: "",
				fieldName: "authorCode",
				disable: true,
				hidden: true,
				span: 12,
			}, {
				type: FormItemTypeEnum.Select,
				fieldLabel: "发布范围",
				fieldName: "receiverTypeCode",
				span: 12,
				ds: ReceiverTypeDs,
				rules: [
					{ required: true, message: "请选择发布范围" }
				],
				// onChange: (v) => setReceiverTypeCode(v)
			}, {
				type: FormItemTypeEnum.Datepicker,
				format: "YYYY-MM-DD HH:mm:ss",
				showTime: true,
				fieldLabel: "发布时间",
				fieldName: "pubTime",
				disabledDate: disabledDate,
				disabledDateTime: disabledDateTime,
				rules: [
					{ required: true, message: "请选择时间" }
				],
				span: 12,
			}, {
				// type: FormItemTypeEnum.TreeSelect,
				// fieldLabel: "接收范围",
				// fieldName: "receiverValue",
				span: 12,
				// disable: receiverTypeCode ? receiverTypeCode === 'ALL' : true,
				// treeDs: orgDs,
				// onChange: debounceFetcher,
				// treeCheckable: receiverTypeCode === 'ORG',
				// filterOption: (inputValue: string, option: ISelectOption) => option.label.includes(inputValue),
				type: FormItemTypeEnum.Other,
				fieldLabel: "",
				fieldName: "",
				formItem: (
					<Form.Item noStyle shouldUpdate={(prevValue, currentValue) => { return prevValue.receiverTypeCode !== currentValue.receiverTypeCode }}>
						{
							({ getFieldValue, getFieldsValue, setFieldsValue }) => {
								const receiverTypeCode = getFieldValue('receiverTypeCode');
								const receiverValue = getFieldValue('receiverValue');
								if (receiverTypeCode === 'USER' && Array.isArray(receiverValue)) {
									// setFieldsValue({
									//   receiverValue: "yh",
									// })
									debounceFetcher('yh')
								}
								if (receiverTypeCode !== 'USER') {
									setFieldsValue({
										receiverValue: [],
										receiverUserCode: []
									})
								}
								// debugger
								return <Form.Item label="接收机构" name="receiverValue">
									<TreeSelect
										disabled={editModel === "look" || receiverTypeCode === 'ALL' || receiverTypeCode === 'USER'}
										allowClear={true}
										treeData={orgDs}
										// treeCheckable={receiverTypeCode === 'ORG'}
										multiple={receiverTypeCode === 'ORG'}
										onChange={(v: string) => {
											if (receiverTypeCode !== 'USER') return undefined
											return debounceFetcher(v);
										}
										}
									/>
								</Form.Item>
							}
						}
					</Form.Item>
				)
			}, {
				type: FormItemTypeEnum.Datepicker,
				format: "YYYY-MM-DD HH:mm:ss",
				fieldLabel: "时效日期",
				fieldName: "limitTime",
				disabledDate: disabledDate,
				disabledDateTime: disabledDateTime,
				span: 12,
				// disable: limitTimeDisabled,
			}, {
				// type: FormItemTypeEnum.Select,
				// fieldLabel: "用户",
				// fieldName: "receiverUserCode",
				// hidden: 
				type: FormItemTypeEnum.Other,
				fieldLabel: "",
				fieldName: "",
				span: 12,
				formItem: <Form.Item
					noStyle
					shouldUpdate={(prevValues, currentValues) => {
						return prevValues.receiverTypeCode !== currentValues.receiverTypeCode
					}}
				>
					{
						({ getFieldValue, setFieldsValue }) => {
							const receiverTypeCode = getFieldValue("receiverTypeCode")
							return <Form.Item name="receiverUserCode" label="接收用户" >
								<Select
									disabled={receiverTypeCode !== 'USER'}
									mode="multiple"
									options={userList}
									onChange={(v) => cacheData({ receiverUserCode: v })}
									filterOption={filterOption as any}
								/>
							</Form.Item>
						}
					}
				</Form.Item >
			}, {
				type: FormItemTypeEnum.Switch,
				fieldLabel: "是否长期",
				fieldName: "allTime",
				span: 12,
				// onChange: (value) => { setLimitTimeDisabled(value) }
			}, {
				type: FormItemTypeEnum.Switch,
				fieldLabel: "是否置顶",
				fieldName: "topFlag",
				span: 12,
			}
		]
	};
	const normFile = (e: UploadChangeParam) => {
		let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
		let isType: boolean = false;
		let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf("."));
		isType = filetypes?.includes(fileEnd) ?? false;
		console.log('Upload event:', e);
		if (e?.file.status === 'done' && e?.file.response.retCode === 0) {
			const data = {
				name: e.file.name,
				size: e.file.size,
				type: e.file.type,
				uid: e.file.response.retData
			}
			e.fileList[e.fileList.length - 1] = data
		}
		if (Array.isArray(e)) {
			return e;
		}
		if (!isType) {
			e.fileList?.pop()
		}
		return e && e.fileList;
	};

	//富文本扩展上传图片
	const uploadHandler = (param: any) => {
		if (param.file.status === "done") {
			try {
				let content = formRef.current?.getFieldsValue()?.content;
				// let md5 = `${fileUrl}/file/fetch?id=${param.file?.response?.retData ?? ""}`
				let md5 = getBaseImgLookUrl(param.file?.response?.retData ?? "")
				console.log(md5)
				// console.log(formRef, formRef.current?.getFieldsValue(), param.file?.response?.retData)
				formRef.current?.setFieldsValue({
					content: ContentUtils.insertMedias(content, [{
						type: 'IMAGE',
						url: md5
					}]
					)
				})
			} catch (err) { }
		}
	}

	const extendControls: ExtendControlType[] = [
		{
			key: 'antd-uploader',
			type: 'component',
			component: (
				<Upload
					accept="image/*"
					showUploadList={false}
					onChange={uploadHandler}
					name="file"
                    action={getBaseImgUploadUrl()}
                    data={getBaseUploadData()}
				>
					{/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
					<button type="button" className="control-item button upload-button" data-title="插入图片">上传图片</button>
				</Upload>
			)
		}
	]

	return (
		<ErrorBoundary
			message={<div>富文本表格操作过于频繁导致数据录入异常！！！2秒后关闭此页面</div>}
			description={<span ></span>}
		>
			<ErrorBoundary1
				fallback={(error: any, info: any) => {
					message.warning("富文本表格操作过于频繁导致数据录入异常！！！2秒后关闭此页面")
					setTimeout(() => { closeNav(selectedNavId) }, 2000)
				}}>
				<Spin spinning={loading} tip="Loading...">
					<YhBox title="发布公告">
						<div style={{ padding: "20px" }}>
							<YhForm  {...formConfig} >
								<Col span={24} key="content">
									<Form.Item
										label="公告内容"
										name="content"
										labelCol={{
											span: 3
										}}
										required={true}
										rules={[
											{ required: true, message: "请输入公告内容" }
										]}
									>
										<BraftEditor
											readOnly={editModel === 'look'}
											style={{ border: "1px solid #ccc", borderRadius: "6px" }}
											className="my-editor"
											// controls={controls}
											placeholder="请输入正文内容"
											extendControls={extendControls}
										/>
									</Form.Item>
								</Col>
								<Col span={12} key="attachCode">
									<Form.Item
										name="attachCode"
										label="附件"
										valuePropName="fileList"
										getValueFromEvent={normFile}
									>
										<Upload
											name="fileName"
											action={getBaseRequestUrl() + "/oa/notice/uploadAttach"}
											headers={{
												authorization: getToken()
											}}
											listType="picture"
											disabled={editModel === 'look'}
											beforeUpload={(file) => {
												let fileEnd: string = file.name.substring(file.name.lastIndexOf("."));
												let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
												// var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
												let isType = filetypes?.includes(fileEnd);
												if (!isType) {
													message.error('不支持该格式的上传');
												}
												const isLt20M = file.size / 1024 / 1024 < 20;
												if (!isLt20M) {
													message.error('上传到文件不能超过20M');
												}
												return isType && isLt20M;
											}}

											iconRender={(file) => {
												if (file.type.indexOf('image/') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
												if (file.type.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
											}}
										>
											<Button icon={<UploadOutlined />}>选择文件上传</Button>
										</Upload>
									</Form.Item>
								</Col>
							</YhForm>
							<div className="flex justify-end pt-20">
								<YhAuth resCode="portal2.n.issue.send">
									<Button shape="round" type="link" hidden={selectedRowData?.status === 1 || editModel === 'look'} onClick={() => onSubmit('publish')}>发送</Button>
								</YhAuth>
								<YhAuth resCode="portal2.n.issue.pvw">
									<Button shape="round" type="link" onClick={onPreview}>预览</Button>
								</YhAuth>
								<YhAuth resCode="portal2.n.issue.save">
									<Button shape="round" type="link" hidden={selectedRowData?.status === 1 || editModel === 'look'} onClick={() => onSubmit('save')}>保存</Button>
								</YhAuth>
								<Button shape="round" type="link" onClick={() => replaceNav(selectedNavId, "portal-04")}>返回</Button>
							</div>
						</div>
						<DetailDrawer />
					</YhBox >
				</Spin>
			</ErrorBoundary1>
		</ErrorBoundary>
	)
}
